var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEnterProfile = function SvgEnterProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 288 142"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#enter_profile_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 288,
    height: 142,
    fill: "#fff",
    rx: 9.6
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#enter_profile_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99.2,
    height: 112,
    x: 86,
    y: 18.689,
    fill: "#FBFBFF",
    rx: 9.6,
    transform: "rotate(-4.445 86 18.689)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 98.4,
    height: 111.2,
    x: 86.43,
    y: 19.056,
    stroke: "#EFF1F9",
    strokeWidth: 0.8,
    rx: 9.2,
    transform: "rotate(-4.445 86.43 19.056)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 85.6,
    height: 54.4,
    x: 96.961,
    y: 66.783,
    fill: "#EFF1F9",
    rx: 3.2,
    transform: "rotate(-4.445 96.96 66.783)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 8.8,
    x: 93.859,
    y: 26.904,
    fill: "#EFF1F9",
    rx: 1.6,
    transform: "rotate(-4.445 93.86 26.904)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 72.8,
    height: 8.8,
    x: 94.852,
    y: 39.665,
    fill: "#EFF1F9",
    rx: 1.6,
    transform: "rotate(-4.445 94.852 39.665)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#enter_profile_svg__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99.2,
    height: 112,
    x: 103.391,
    y: 11.676,
    fill: "#FBFBFF",
    rx: 9.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 98.4,
    height: 111.2,
    x: 103.791,
    y: 12.076,
    stroke: "#EFF1F9",
    strokeWidth: 0.8,
    rx: 9.2
  })), /*#__PURE__*/React.createElement("rect", {
    width: 85.6,
    height: 54.4,
    x: 110.59,
    y: 60.476,
    fill: "#EEEBFA",
    rx: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 8.8,
    x: 110.59,
    y: 20.476,
    fill: "#EFF1F9",
    rx: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 72.8,
    height: 8.8,
    x: 110.59,
    y: 33.275,
    fill: "#EFF1F9",
    rx: 1.6
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#enter_profile_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5A5E7F",
    d: "M224.499 120.3a3.799 3.799 0 0 0 2.687-6.486L210.122 96.75a3.799 3.799 0 1 0-5.373 5.373l17.064 17.064a3.78 3.78 0 0 0 2.686 1.113"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4E7F4",
    d: "M214.297 82.898c0-12.901-10.496-23.399-23.399-23.399-6.45 0-12.3 2.624-16.537 6.86l33.075 33.076c4.237-4.237 6.861-10.087 6.861-16.538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFF1F9",
    d: "m207.434 99.435-33.076-33.076c-4.237 4.237-6.861 10.088-6.861 16.538 0 12.901 10.498 23.398 23.399 23.398 6.45 0 12.301-2.623 16.538-6.86"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80839E",
    d: "M190.896 109.145c14.474 0 26.249-11.775 26.249-26.247s-11.773-26.249-26.249-26.249-26.247 11.775-26.247 26.249 11.775 26.247 26.247 26.247m0-46.796c11.332 0 20.549 9.22 20.549 20.549 0 11.33-9.219 20.547-20.549 20.547s-20.547-9.22-20.547-20.547 9.219-20.549 20.547-20.549"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "enter_profile_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 288,
    height: 142,
    fill: "#fff",
    rx: 9.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "enter_profile_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M234 50h-76v76h76z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "enter_profile_svg__b",
    width: 107.752,
    height: 120.323,
    x: 86.715,
    y: 11.714,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.6,
    dy: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937255 0 0 0 0 0.945098 0 0 0 0 0.976471 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3245_10534"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3245_10534",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "enter_profile_svg__c",
    width: 100.799,
    height: 114.4,
    x: 103.391,
    y: 11.676,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.6,
    dy: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937255 0 0 0 0 0.945098 0 0 0 0 0.976471 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3245_10534"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3245_10534",
    result: "shape"
  })))));
};
export { SvgEnterProfile as ReactComponent };
export default "data:image/svg+xml;base64,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";